/**
 * Converia Registration CartHandler
 */

Converia.Core.module('Converia.Registration.PaymentInternalHandler', function () {
    var PaymentInternalHandler = function () {

    };
    PaymentInternalHandler.prototype.takeEntry = function (element, selectedValue) {
        element.val(selectedValue).change();
    }

    PaymentInternalHandler.prototype.setDebitorDescription = function (setValue, descriptionData, descriptionElement) {
        let text = descriptionData[1];
        if (setValue !== '') {
            let data = descriptionData[0];
            for (let i = 0; i < data.length; i++) {
                if (data[i].debitor === setValue) {
                    text += data[i].name + ', ' + data[i].street + ', ' + data[i].postcode + ', ' + data[i].town;
                    break;
                }
            }
        }
        descriptionElement.text(text);
    }

    return PaymentInternalHandler;
});